// UI metadata for subjects + sections.
import { Sigma, FlaskConical, Atom, Compass, Move3d, TrendingUp, Hash, BookOpen, Zap, Wind, Eye, Cpu, Beaker, Hexagon } from 'lucide-react';

const SUBJECT_META = {
  math:      { icon: Sigma,        accent: 'indigo' },
  physics:   { icon: Atom,         accent: 'rose' },
  chemistry: { icon: FlaskConical, accent: 'emerald' },
};

const MATH_SECTION_META = {
  'algebra':              { icon: Sigma,       accent: 'indigo',  blurb: 'Polynomials, sequences, combinatorics & matrices.' },
  'trigonometry':         { icon: Compass,     accent: 'rose',    blurb: 'Identities, equations & properties of triangles.' },
  'coordinate-geometry':  { icon: Move3d,      accent: 'amber',   blurb: 'Lines, conics, locus & analytic methods.' },
  'calculus':             { icon: TrendingUp,  accent: 'emerald', blurb: 'Limits, differentiation, integration & applications.' },
  'vector-and-3d':        { icon: Hash,        accent: 'sky',     blurb: 'Vector algebra, lines & planes in space.' },
  'vector-3d':            { icon: Hash,        accent: 'sky',     blurb: 'Vector algebra, lines & planes in space.' },
  'other':                { icon: BookOpen,    accent: 'slate',   blurb: 'Miscellaneous & cross-topic problems.' },
};

const PHYSICS_SECTION_META = {
  'mechanics':        { icon: Move3d,      accent: 'rose',    blurb: 'Kinematics, Newton’s laws, work, energy & rotation.' },
  'thermal-waves':    { icon: Wind,        accent: 'amber',   blurb: 'Thermodynamics, oscillations & wave phenomena.' },
  'electromagnetism': { icon: Zap,         accent: 'sky',     blurb: 'Electrostatics, current, magnetism & induction.' },
  'optics':           { icon: Eye,         accent: 'indigo',  blurb: 'Ray optics, wave optics & interference.' },
  'modern-physics':   { icon: Cpu,         accent: 'emerald', blurb: 'Atoms, nuclei, dual nature & semiconductors.' },
};

const CHEMISTRY_SECTION_META = {
  'physical':  { icon: Beaker,        accent: 'emerald', blurb: 'Atomic structure, thermodynamics & equilibrium.' },
  'organic':   { icon: Hexagon,       accent: 'amber',   blurb: 'Hydrocarbons, functional groups & biomolecules.' },
  'inorganic': { icon: FlaskConical,  accent: 'sky',     blurb: 'Periodic table, bonding & coordination compounds.' },
};

export function subjectMeta(subjectId) {
  return SUBJECT_META[subjectId] || SUBJECT_META.math;
}

export function sectionMeta(slug, subjectId = 'math') {
  const maps = { math: MATH_SECTION_META, physics: PHYSICS_SECTION_META, chemistry: CHEMISTRY_SECTION_META };
  const map = maps[subjectId] || MATH_SECTION_META;
  return map[slug] || { icon: BookOpen, accent: 'slate', blurb: '' };
}
